import { BoMItemRow } from 'model/Project/BoMItemRow'
import {
  ArticleIdFilter,
  ManufacturabilityCheckFilter,
  PartTypeIdFilter,
  ResourceIdFilter,
} from 'store/Project/ProjectTypes'
import {
  showPartBasedOnArticleId,
  showPartBasedOnManufacturability,
  showPartBasedOnPartTypeId,
  showPartBasedOnResourceId,
} from './showPartBasedOnPartTypeId'

export function applyPartTypeIdFilter(
  filter: PartTypeIdFilter,
  row: BoMItemRow
): boolean {
  let partTypeIdFilterAppliedShowItem = true

  switch (row.type) {
    case 'Row': {
      partTypeIdFilterAppliedShowItem = showPartBasedOnPartTypeId(row, filter)
    }
  }

  return partTypeIdFilterAppliedShowItem
}

export function applyArticleIdFilter(
  filter: ArticleIdFilter,
  row: BoMItemRow
): boolean {
  let partTypeIdFilterAppliedShowItem = false

  switch (row.type) {
    case 'Row': {
      partTypeIdFilterAppliedShowItem = showPartBasedOnArticleId(row, filter)
    }
  }

  return partTypeIdFilterAppliedShowItem
}

export function applyResourceIdFilter(
  filter: ResourceIdFilter,
  row: BoMItemRow
): boolean {
  let partTypeIdFilterAppliedShowItem = false

  switch (row.type) {
    case 'Row': {
      partTypeIdFilterAppliedShowItem = showPartBasedOnResourceId(
        row.workingSteps,
        filter
      )
      break
    }
    case 'AssemblyHeader': {
      partTypeIdFilterAppliedShowItem = showPartBasedOnResourceId(
        row.assembly.assemblyWorkingStepDtos.concat(
          row.assembly.partTypeWorkingStepDtos
        ),
        filter
      )
      break
    }
  }

  return partTypeIdFilterAppliedShowItem
}

export function applyManufacturabilityFilter(
  filter: ManufacturabilityCheckFilter,
  row: BoMItemRow
): boolean {
  let manufacturabilityCheckFilterApplied = true

  switch (row.type) {
    case 'Row':
      {
        manufacturabilityCheckFilterApplied = showPartBasedOnManufacturability(
          row,
          filter
        )
      }
      break
  }

  return manufacturabilityCheckFilterApplied
}
